import type { LeadsRepository } from '~~/core/ports/repositories/LeadsRepository';

import { Result } from '~~/core/helpers/result';
import { createOriginalErrorObject } from '~~/server/utils/errorHandling';

export const nuxtLeadsRepository: LeadsRepository = {
	async createPropertyLead(params, _accessToken: never) {
		try {
			const response = await $fetch('/api/leads/properties', {
				method: 'POST',
				body: params
			});

			return Result.ok(response);
		} catch (error) {
			return Result.error({
				message: 'Error while creating a property lead.',
				source: 'nuxtLeadsRepository.createPropertyLead',
				originalErrorObject: createOriginalErrorObject(error)
			});
		}
	},
	async createCondoLead(params, _accessToken: never) {
		try {
			const response = await $fetch('/api/leads/condos', {
				method: 'POST',
				body: params
			});

			return Result.ok(response);
		} catch (error) {
			return Result.error({
				message: 'Error while creating a condominium lead.',
				source: 'nuxtLeadsRepository.createCondoLead',
				originalErrorObject: createOriginalErrorObject(error)
			});
		}
	},
	async createCreditLead(params) {
		try {
			const response = await $fetch('/api/leads/credit', {
				method: 'POST',
				body: params
			});

			return Result.ok(response);
		} catch (error) {
			return Result.error({
				message: 'Error while creating a credit lead.',
				source: 'nuxtLeadsRepository.createCreditLead',
				originalErrorObject: createOriginalErrorObject(error)
			});
		}
	}
};
